import unionBy from 'lodash/unionBy';
import {
  GET_TEAMS,
  DELETE_TEAM,
  GET_CALL_HOUR_GROUPS,
  GET_CONTACT_CALLERS,
  DELETE_CONTACT_CALLER,
  GET_CALL_MENUS,
  GET_CALL_MENU_OPTIONS,
  SAVE_CALL_HOUR_GROUP,
  SAVE_CALL_MENU,
  SAVE_CALL_MENU_OPTION,
  GET_CALL_MENU,
  DELETE_CALL_MENU,
} from './types';
import { resolved, rejected } from '../../createAction';

const initialState = {
  teams: {
    loading: false,
    data: [],
    error: null,
  },
  callers: {
    loading: false,
    data: [],
    error: null,
  },
  callHourGroups: {
    loading: false,
    data: [],
    error: null,
  },
  callMenus: {
    loading: false,
    data: [],
    error: null,
  },
  callMenuOptions: {
    loading: false,
    data: [],
    error: null,
  },
  saving: false,
};

const collectionReducer = (
  state = {
    loading: false,
    data: [],
    error: null,
  },
  action,
) => {
  const { payload } = action;
  if (payload) {
    if (payload.message) {
      return {
        ...state,
        loading: false,
        error: payload.message,
      };
    }
    return {
      ...state,
      loading: false,
      data: payload,
    };
  }
  return {
    ...state,
    loading: true,
    error: null,
  };
};

export default function (state = initialState, action) {
  const { type, meta } = action;
  switch (type) {
    case GET_TEAMS:
    case rejected(GET_TEAMS):
    case resolved(GET_TEAMS):
      return {
        ...state,
        teams: collectionReducer(state.teams, action),
      };
    case resolved(DELETE_TEAM):
      return {
        ...state,
        teams: {
          ...state.teams,
          data: state.teams.data.filter((team) => team.hash !== meta.hash),
        },
      };
    case GET_CONTACT_CALLERS:
    case rejected(GET_CONTACT_CALLERS):
    case resolved(GET_CONTACT_CALLERS):
      return {
        ...state,
        callers: collectionReducer(state.callers, action),
      };
    case resolved(DELETE_CONTACT_CALLER):
      return {
        ...state,
        callers: {
          ...state.callers,
          data: state.callers.data.filter(
            (caller) => caller.hash !== meta.hash,
          ),
        },
      };
    case GET_CALL_HOUR_GROUPS:
    case rejected(GET_CALL_HOUR_GROUPS):
    case resolved(GET_CALL_HOUR_GROUPS):
      return {
        ...state,
        callHourGroups: collectionReducer(state.callHourGroups, action),
      };
    case GET_CALL_MENUS:
    case rejected(GET_CALL_MENUS):
    case resolved(GET_CALL_MENUS):
      return {
        ...state,
        callMenus: collectionReducer(state.callMenus, action),
      };
    case GET_CALL_MENU_OPTIONS:
    case rejected(GET_CALL_MENU_OPTIONS):
    case rejected(SAVE_CALL_MENU_OPTION):
    case rejected(SAVE_CALL_MENU):
    case rejected(SAVE_CALL_HOUR_GROUP):
    case rejected(DELETE_CALL_MENU):
    case resolved(GET_CALL_MENU_OPTIONS):
      return {
        ...state,
        callMenuOptions: collectionReducer(state.callMenuOptions, action),
      };
    case resolved(SAVE_CALL_MENU_OPTION):
      return {
        ...state,
        callMenuOptions: {
          ...state.callMenuOptions,
          data: state.callMenuOptions.data.map((item) => {
            if (item.hash === action.payload.hash) {
              return action.payload;
            }
            return item;
          }),
        },
      };
    case resolved(SAVE_CALL_MENU):
    case resolved(GET_CALL_MENU):
      return {
        ...state,
        callMenus: {
          ...state.callMenus,
          data: state.callMenus.data.map((item) => {
            if (item.hash === action.payload.hash) {
              return action.payload;
            }
            return item;
          }),
        },
      };
    case resolved(SAVE_CALL_HOUR_GROUP):
      return {
        ...state,
        callHourGroups: {
          ...state.callHourGroups,
          data: state.callHourGroups.data.map((item) => {
            if (item.hash === action.payload.hash) {
              return action.payload;
            }
            return item;
          }),
        },
      };
    case resolved(DELETE_CALL_MENU):
      return {
        ...state,
        callMenus: {
          ...state.callMenus,
          data: state.callMenus.data.filter((item) => item.hash !== meta.hash),
        },
      };
    default:
      return state;
  }
}
